import { render, staticRenderFns } from "./answerListCustomers.vue?vue&type=template&id=1a2b6312"
import script from "./answerListCustomers.vue?vue&type=script&lang=js"
export * from "./answerListCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports